import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Form,
  Message,
  Tab,
  Menu,
  Label,
  Button,
  Comment,
  Icon,
  Input
} from 'semantic-ui-react';
import { BankDetails } from '../../components';
import { enums, validators } from '../../helpers';
import { isEqual } from 'lodash';
import moment from 'moment';
import IBAN from 'iban';

import 'semantic-ui-css/components/modal.min.css';
import 'semantic-ui-css/components/dimmer.min.css';
import 'semantic-ui-css/components/transition.min.css';
import 'semantic-ui-css/components/tab.min.css';
import 'semantic-ui-css/components/menu.min.css';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/form.min.css';
import 'semantic-ui-css/components/dropdown.min.css';
import 'semantic-ui-css/components/message.min.css';
import 'semantic-ui-css/components/comment.min.css';
import 'semantic-ui-css/components/table.min.css';

import './EditReturnedRefundModal.css';

const statusOptions = [
  {
    key: "NEW",
    value: "NEW",
    text: "New"
  }, {
    key: "REQUESTED",
    value: "REQUESTED",
    text: "Requested",
    disabled: true
  }, {
    key: "RETURNED",
    value: "RETURNED",
    text: "Returned",
    disabled: true
  }, {
    key: "APPROVED",
    value: "APPROVED",
    text: "Approved",
    disabled: true
  }, {
    key: "REJECTED",
    value: "REJECTED",
    text: "Rejected",
    disabled: true
  }, {
    key: "COMPLETED",
    value: "COMPLETED",
    text: "Completed",
    disabled: true
  }
];

const priorityOptions = [
  {
    key: "HIGH",
    value: "HIGH",
    text: <span className="priority-icon-form"><Icon name="angle double up" color="red" /> High</span>
  }, {
    key: "NORMAL",
    value: "NORMAL",
    text: <span className="priority-icon-form"><Icon name="angle double down" color="green" /> Normal</span>
  }
];

export default class NewRefundRequestModal extends Component {
  static propTypes = {
    updateRefund: PropTypes.func,
    submitComment: PropTypes.func,
    initialValues: PropTypes.obj,
    addComment: PropTypes.func,
    operators: PropTypes.obj
  }

  constructor(props) {
    super(props);
    this.state = {
      priority: this.props.initialValues ? this.props.initialValues.priority : null,
      method: this.props.initialValues ? this.props.initialValues.refundMethod : null,
      msisdn: this.props.initialValues ? this.props.initialValues.msisdn : null,
      currency: this.props.initialValues ? this.props.initialValues.amount.currency : null,
      amount: this.props.initialValues ? this.props.initialValues.amount.value : null,
      processingFee: this.props.initialValues ? this.props.initialValues.amount.processingFee : 0,
      name: this.props.initialValues ? this.props.initialValues.name : null,
      email: this.props.initialValues ? this.props.initialValues.email : null,
      entity: this.props.initialValues ? this.props.initialValues.entity : null,
      changed: false,
      comment: '',
      confirmOpen: false,
      bankDetails: this.props.initialValues ? this.props.initialValues.bankDetails : {},
      errors: {}
    }
  }

  componentWillReceiveProps(nextProps) {
    const { comments: commentsNextProps, ...otherNextProps } = nextProps.initialValues || {};
    const { comments: commentThisProps, ...otherThisProps } = this.props.initialValues || {};
    // don't update state if user added a new comment
    if (!isEqual(otherNextProps, otherThisProps) && nextProps.initialValues) {
      this.setState({
        priority: nextProps.initialValues.priority,
        method: nextProps.initialValues.refundMethod,
        msisdn: nextProps.initialValues.msisdn,
        currency: nextProps.initialValues.amount.currency,
        amount: nextProps.initialValues.amount.value,
        processingFee: nextProps.initialValues.amount.processingFee,
        name: nextProps.initialValues.name,
        email: nextProps.initialValues.email,
        entity: nextProps.initialValues.entity,
        bankDetails: nextProps.initialValues.bankDetails
      })
    }
  }

  validateInputs = () => {
    const errors = {};
    if (!this.state.msisdn) errors.msisdn = "You must specify a msisdn";
    if (!this.state.currency) errors.currency = "You must specify a currency";
    if (!this.state.amount) errors.amount = "You must specify a amount";
    if (!this.state.method) errors.method = "You must specify a method";
    if (!this.state.name) errors.name = "You must specify a name";
    //if (!this.state.email) errors.email = "You must specify a email";
    if (!this.state.priority) errors.priority = "You must specify a priority";
    if (!this.state.entity) errors.entity = "You must specify a entity";
    if (this.state.method === 'pending_information' || this.state.method === 'to_be_defined') errors.method = "Refund method can't be Pending";
    if (this.state.email && !validators.validateEmail(this.state.email)) errors.email = "email not valid";
    if (this.state.msisdn && !validators.validateMSISDN(this.state.msisdn)) errors.msisdn = "MSISDN not valid";
    if (this.state.amount && !validators.validateNumber(this.state.amount)) errors.amount = "amount not valid";
    if (this.state.processingFee && !validators.validateNumber(this.state.processingFee) && this.state.processingFee < 0) errors.processingFee = "processing fee not valid";
    if (this.state.entity && this.state.method) {
      enums.entityToRefundMethod[this.state.entity][this.state.method].forEach(field => {
        if (!this.state.bankDetails[field] && this.state.method !== 'bill_payment') {
          errors[`bankDetails${field}`] = `you must specify ${field.toLowerCase()}`;
        }
      })
      if (enums.entityToRefundMethod[this.state.entity][this.state.method].includes('iban') && this.state.bankDetails.iban && !IBAN.isValid(this.state.bankDetails.iban))
        errors.bankDetailsiban = "IBAN is not valid";
    }
    return errors;
  }


  handleSubmit = () => {
    const errors = this.validateInputs();
    document.getElementsByClassName('EditReqModalContent')[0].scrollTo(0, 0)
    if (Object.keys(errors).length) {
      this.setState({ errors });
    } else {
      const { changed, comment, errors, ...fields } = this.state;
      this.props.close();
      this.props.updateReturnedRefund(this.props.open, fields);
    }

  }

  submitComment = () => {
    this.props.addComment(this.props.open, this.state.comment)
    this.setState({ comment: '' })
  }

  onItemChange = (field) => (e, { value }) => this.setState({ [field]: value, changed: true })

  onBankDetailsFieldChange = (field) => (e, { value }) => this.setState({
    bankDetails: {
      ...this.state.bankDetails,
      [field]: value
    },
    changed: true,
    errors: {
      ...this.state.errors,
      [`bankDetails${field}`]: undefined
    }
  })

  closeModal = () => {
    if (this.state.changed && this.state.confirmOpen !== 'closing' && !this.state.confirmOpen) {
      this.setState({ confirmOpen: true })
    } else if (!this.state.confirmOpen && this.state.confirmOpen !== 'closing') {
      this.props.close();
      this.resetFields();
    } else if (this.state.confirmOpen === 'closing') this.setState({confirmOpen: false})
  }

  closeConfirm = () => {
    this.setState({ confirmOpen: 'closing' });
  }

  confirmCloseModal = () => {
    this.setState({ confirmOpen: false });
    this.resetFields();
    this.props.close();
  }

  resetFields = () => {
    this.setState({ errors: {} })
  }

  handleUpload = (event) => {
    const data = new FormData();
    data.append('file', event.target.files[0])
    event.target.value = null;
    this.props.uploadFiles(this.props.open, data);
  }

  handleImagePaste = (event) => {
    const items = (event.clipboardData  || event.originalEvent.clipboardData).items;

    let blob = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") === 0) {
        blob = items[i].getAsFile();
      }
    }
    if (blob) {
      const data = new FormData();
      data.append('file', blob)
      this.props.uploadFiles(this.props.open, data);
    }
  }

  renderProcessingFeeField = () =>{    
    if(this.state.method === "topup"){
      return <Form.Input
      label="Processing Fee"
      value={this.state.processingFee}
      error={this.state.errors && this.state.errors.processingFee}
      fluid
      onChange={this.onItemChange('processingFee')}
    />
    }

    return "";
  }

  render() {
    const countries = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryName
    }), {}) : {};
    const countryOptions = Object.keys(countries).map(Number).map(countryId => ({ key: countryId, value: countryId, text: countries[countryId] }));
    const operatorOptions = this.props.initialValues ? this.props.operators.filter(operator => operator.countryId === this.props.initialValues.countryId).map(operator => ({ key: operator.oc, value: operator.oc, text: operator.operatorName })) : [];
    const serviceOptions = this.props.initialValues && this.props.operators ? this.props.operators.find(operator => operator.oc === this.props.initialValues.oc).services.map(service => ({ key: service.id, value: service.id, text: service.name })) : [];

    console.log(this.props, serviceOptions);
    return (
      <Modal
        className="EditReturnedRefundModal"
        open={this.props.open}
        onClose={this.closeModal}
        mountNode={document.getElementById('root')}
        closeIcon
      >
        <Modal.Header>Edit Request</Modal.Header>
        {this.props.initialValues ? <Modal.Content scrolling className="EditReqModalContent">
          {this.state.errors && Object
            .values(this.state.errors)
            .filter(item => item).length ? <Message
              error
              size="mini"
              header='Oops, Something Went Wrong'
              list={[
                ...Object.values(this.state.errors).filter(item => item),
              ]}
            /> : null }
          <Form className="TicketContent" size='mini' loading={!this.props.initialValues}>
              <div className="former-group">
              <Form.Input
              value={this.props.initialValues.zendeskTicket}
              placeholder="Zendesk Ticket"
              readOnly disabled
              label="ZenDesk Ticket #"
            />
              </div>
              <div className="former-group">
              <Form.Dropdown
                label="Country"
                value={this.props.initialValues.countryId}
                selection
                readOnly
                disabled
                fluid
                options={countryOptions}
              />
              <Form.Dropdown
                label="Operator"
                value={this.props.initialValues.oc}
                selection
                readOnly
                disabled
                fluid
                options={operatorOptions}
              />
              <Form.Dropdown
                label="Service"
                value={this.props.initialValues.srvcId.toString()}
                selection
                readOnly
                disabled
                fluid
                options={serviceOptions}
              />
              </div>
              <div className="former-group">
                  <Form.Input
                      fluid
                      label="Entity"
                      value={this.state.entity}
                      error={this.state.errors && this.state.errors.entity}
                      readOnly
                      disabled
                  />
                  <Form.Dropdown
                      label="Refund Method"
                      selection
                      value={this.state.method}
                      error={this.state.errors && this.state.errors.method}
                      onChange={this.onItemChange('method')}
                      fluid
                      options={Object.keys(enums.refundMethods).map(method => ({ key: method, value: method, text: enums.refundMethods[method], disabled: !(this.state.entity && Object.keys(enums.entityToRefundMethod[this.state.entity]).includes(method)) }))}
                  />
                  <BankDetails
                      entity={this.state.entity}
                      refundMethod={this.state.method}
                      initialValues={this.state.bankDetails}
                      onFieldChange={this.onBankDetailsFieldChange}
                      errors={this.state.errors}
                      prefix="bankDetails"
                  />
              </div>
              <div className="former-group">
              <Form.Dropdown
                label="Priority"
                value={this.state.priority}
                onChange={this.onItemChange('priority')}
                error={this.state.errors && this.state.errors.priority}
                selection
                fluid
                options={priorityOptions}
              />
              <Form.Dropdown
                label="Status"
                value={this.props.initialValues.status}
                selection
                fluid
                readOnly
                disabled
                options={statusOptions}
              />
              </div>
              <div className="former-group">
              <Form.Input
                label="MSISDN"
                value={this.state.msisdn}
                error={this.state.errors && this.state.errors.msisdn}
                onChange={this.onItemChange('msisdn')}
              />
              <Form.Dropdown
                label="Currency"
                value={this.state.currency}
                onChange={this.onItemChange('currency')}
                error={this.state.errors && this.state.errors.currency}
                selection
                fluid
                options={Object.keys(enums.currencies).map(currency => ({ key: currency, value: currency, text: enums.currencies[currency] }))}
              />
              <Form.Input
                label={'Amount'}
                value={this.state.amount}
                error={this.state.errors && this.state.errors.amount}
                fluid
                onChange={this.onItemChange('amount')}
              />
              {this.renderProcessingFeeField()}
              </div>

              <div className="former-group">
              <Form.Input
                label="Name"
                value={this.state.name}
                error={this.state.errors && this.state.errors.name}
                onChange={this.onItemChange('name')}
              />
              <Form.Input
                label="Email"
                value={this.state.email}
                error={this.state.errors && this.state.errors.email}
                onChange={this.onItemChange('email')}
              />
              </div>
          </Form>
          <Tab
            className="DetailsTab"
            panes={[{
                menuItem: <Menu.Item key='comments'>Comments<span className="tab-value">&nbsp;({this.props.initialValues.comments.length})</span></Menu.Item>,
                render: () => <Tab.Pane>
                  <Comment.Group>
                    {this.props.initialValues.comments.length ? this.props.initialValues.comments.map(comment => <Comment>
                      <Comment.Content>
                          <div className="comment-title-wrapper clearfix">
                        <Comment.Author as='span'>{comment.user.email}</Comment.Author>
                        <Comment.Metadata>
                          <div>{moment(comment.date).format('YYYY-MM-DD HH:mm')}</div>
                        </Comment.Metadata>
                          </div>
                        <Comment.Text>{comment.comment}</Comment.Text>
                      </Comment.Content>
                    </Comment>) : 'No comments yet'}
                    <Form reply size="mini">
                      <Form.TextArea className="reply-textarea" onChange={this.onItemChange('comment')} value={this.state.comment} />
                        <div className="button-reply-wrapper"><Button className="button-reply" onClick={this.submitComment}>Reply</Button></div>
                    </Form>
                  </Comment.Group>
                </Tab.Pane>
              }, {
                menuItem: <Menu.Item key='history'>History <span className="tab-value">&nbsp;({this.props.initialValues.history.length})</span></Menu.Item>,
                render: () => <Tab.Pane>
                    <Comment.Group>
                      <div className="history-widget">
                        {this.props.initialValues.history.map(item =>
                        <Comment>
                          <Comment.Content>
                              <div className="comment-title-wrapper clearfix">
                              <Comment.Author as='span'>{item.user.email}</Comment.Author>
                              <Comment.Metadata>
                                <div>{moment(item.date).format('YYYY-MM-DD HH:mm')}</div>
                              </Comment.Metadata>
                              </div>
                              <Comment.Text>{item.change.map(item => {
                                  return (<Label size="mini" className="label-blue">{item.field}: {item.prevValue} => {item.newValue}</Label>)
                              })}</Comment.Text>
                          </Comment.Content>
                        </Comment>) }</div>
                      </Comment.Group>
                </Tab.Pane>
              }, {
                  menuItem: <Menu.Item key='files'>Files <span className="tab-value">&nbsp;({this.props.initialValues.attachments.length})</span></Menu.Item>,
                  render: () => <Tab.Pane>
                      <Label as="label" basic htmlFor="upload" size="mini" disabled={this.props.uploading}>
                        <Button
                          icon="upload"
                          label="Select File"
                          labelPosition="right"
                          size="mini"
                          disabled={this.props.uploading}
                          loading={this.props.uploading}
                        />
                        <input hidden id="upload" type="file" onChange={this.handleUpload} disabled={this.props.uploading} />
                      </Label>
                      <Input size="mini" style={{ marginTop: '20px' }} placeholder='Or Paste here' onPaste={this.handleImagePaste} disabled={this.props.uploading} loading={this.props.uploading} />
                      <Comment.Group>
                        {this.props.initialValues.attachments.length ? this.props.initialValues.attachments.map(attachment => <Comment>
                            <Comment.Content>
                              <div className="comment-title-wrapper clearfix">
                                <Comment.Author as='span'>{attachment.user.email}</Comment.Author>
                                <Comment.Metadata>
                                    <div>{moment(attachment.date).format('YYYY-MM-DD HH:mm')}</div>
                                </Comment.Metadata>
                              </div>
                              <Comment.Text><a href={attachment.url}>{attachment.fileName}</a></Comment.Text>
                            </Comment.Content>
                        </Comment>) : 'No files yet'}
                      </Comment.Group>
                  </Tab.Pane>
              }
            ]}
          />
        </Modal.Content> : null }
          <div className="modaler-footer">
              <div className="modaler-footer__item">
                  <Form.Button onClick={this.closeModal}>Cancel</Form.Button>
              </div>
              <div className="modaler-footer__item">
                  <Form.Button primary onClick={this.handleSubmit}>Update</Form.Button>
              </div>
          </div>
          <Modal
            className="ConfirmCloseModal"
            open={this.state.confirmOpen && this.state.confirmOpen !== 'closing'}
            mountNode={document.getElementById('root')}
            size="mini"
            onClose={this.closeConfirm}
            closeOnDimmerClick={false}
          >
            <Modal.Header>
              <i className="icon1 icon1_circle-question"></i>
              Are you sure?
            </Modal.Header>
            <Modal.Content>
              You have some unsaved changes, are you sure you want to close?
            </Modal.Content>
            <Modal.Actions>
              <Button className="btn" content="No" onClick={this.closeConfirm} />
              <Button className="btn btn_blue" content='Yes' onClick={this.confirmCloseModal} />
            </Modal.Actions>
          </Modal>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditReturnedRefundModalComponent/EditReturnedRefundModal.js